module.exports = __webpack_public_path__ + "img/estatus_excelente.b2689f65.png";